export default __webpack_public_path__ + "static/media/PC_ButtonInActive.37d3f8bd.svg";